/**
 * Created by SH: 02/20/2020
 */


import { BLEND_MODES, Point } from "pixi.js";
import { SanEngineController } from "./SanEngineController";
import { ReelEngineManager } from "../../core/reel/ReelEngineManager";
import { IDimOrientation, LayoutDimData, ResizeHelper } from "../../core/utils/ResizeHelper";
import { MathHelper } from "../../core/utils/MathHelper";
import { SanSpriteSymbol } from "./Symbol/SanSpriteSymbol";
import { GameConfig, SanGameMode } from "../config/base/GameConfig";
import { CommonAnimations } from '../proto/CommonAnimations';
import { RevealerManager } from "../modules/revealer/RevealerManager";
import { SanQuentin2 } from "../SanQuentin2";
import { GameAssets } from "../config/texture/GameAssets";
import { SpinePlayer } from "../../core/displayobject/SpinePlayer";
import { ReelGameData } from "../server/data/ReelGameData";
import { Helper } from "../../core/utils/Helper";
import { AnimationEffects } from "../../core/effects/AnimationEffects";
import { gsap, Power3, Back} from 'gsap';
import { ArrayHelper } from "../../core/utils/ArrayHelper";
import { Sequence } from "../../core/displayobject/Sequence";
import { SoundConfig } from "../config/sound/SoundConfig";
import { SoundManager } from "../config/sound/SoundManager";

export class SanEngineManager extends ReelEngineManager {

    protected static readonly reelDim:IDimOrientation = {
        landscape :{
            scale: new Point(0.85, 0.85),
            position: new Point(60, 158),
        },
        portrait :{
            scale: new Point(1, 1),
            position: new Point(12, 80)
        }
    };

    private maskObj: PIXI.Graphics;
    public static revealer: RevealerManager;

    public static isGambleMode : boolean;
    public static barsApplied : boolean = true;

    // private reelBG_Area: PIXI.Sprite;
    private reelBG: PIXI.Sprite;
    private reelBG_Glow_Spine: SpinePlayer;

    public reelBGSpine: SpinePlayer;
    private ReelDivider: PIXI.Sprite;

    protected extraModules:PIXI.Container;

    public static callReSizeStack: Function[] = [];
    // private static dividers:ReelDivider[] = [];

    public get dim(): LayoutDimData { return SanEngineManager.dim; };
    public static get dim(): LayoutDimData { return ResizeHelper.calcDim(this.reelDim); };
    public static getReel(ID: number): SanEngineController { return <SanEngineController>super.getReel(ID); };

    public static get AllReels(): SanEngineController[] { return <SanEngineController[]>this._reels; };
    // public get AllReels(): SanEngineController[] { return SanEngineManager.AllReels; };

    public static RAll( func:(rc:SanEngineController) => void):void  {
        for(let reel:number = 0; reel < this.AllReels.length;reel++){
            func(this.AllReels[reel]);
        }
    };

    public static RSWindow(func:(rc:SanEngineController, sym:SanSpriteSymbol) => void):void  {
        this.RAll( (rc:SanEngineController) => {
            for(let symID:number = 0; symID < rc.currentWindowAmount;symID++)
                func(rc, rc.AllWindowSymbols[symID]);
        });
    };

    public static RSAll(func:(rc:SanEngineController,sym:SanSpriteSymbol) => void): void  {
        this.RAll( (rc:SanEngineController) => {
            for(let row:number = 0; row < rc.AllSymbols.length;row++)
                func(rc, rc.AllSymbols[row]);
        });
    };

    init(amount: number, initData: any): void {
        super.init(amount, initData);

        this.sortableChildren = true;

        this.reelBGSpine = this.addChild(new SpinePlayer("transporter",true)) 
        this.reelBGSpine.zIndex = -10;
        this.reelBGSpine.position.set(358,325)
        this.reelBGSpine.scale.set(0.99,1.1)
        // this.reelBGSpine.play({animation:"idle",loop:true});

        this.ReelDivider = this.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures(GameAssets.MAIN_GAME_REEL_DIVIDER)[0]));
        this.ReelDivider.anchor.set(0.5);
        this.ReelDivider.zIndex = -2;
        this.ReelDivider.position.set(350, 222);

        this.reelBG = this.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures(GameAssets.FS_GAME_REEL_BG_AREA)[0])) 
        this.reelBG.anchor.set(0.5);
        this.reelBG.zIndex = -10;
        this.reelBG.position.set(348,224)
        this.reelBG.scale.set(1.12,1.09);
        this.reelBG.visible = false;


        this.maskObj = this.createGraphic(undefined,undefined);
        this.maskObj.name = "mask";

        this.extraModules = this.addChild(new PIXI.Container());
        this.extraModules.name = "extraModules";



        this.extraModules.zIndex = 2;

        SanEngineManager.revealer = this.extraModules.addChild(new RevealerManager());

        this.applyMask(false);

        this.reelBG_Glow_Spine = this.addChild(new SpinePlayer("reel_glow")) // animation 
        this.reelBG_Glow_Spine.position.set(350,222)
        this.reelBG_Glow_Spine.scale.set(1.1,1.05);
        this.reelBG_Glow_Spine.zIndex = 4;

        this.sortChildren();
        this.onResize();
    }

    public get showIntroElements():PIXI.DisplayObject[]{
        return [this.reelBG, this.ReelDivider, this.extraModules,this.reelContainer];
    }

    public stopTruck():void{
        // this.reelBGSpine.visible = false;
        this.reelBGSpine.timeLine.repeat(0);
        this.reelBGSpine.timeLine.eventCallback("onComplete", () => {
            this.reelBGSpine.play({animation:"idle",freezed:true });
        })
    }

    public returnToBase():void{
        this.reelBGSpine.stop();
        this.reelBG.visible = false;
        this.onResize();
        this.reelBGSpine.changeSpine("transporter");
        this.reelBGSpine.play({animation:"idle", loop:true });
        this.showIntroElements.forEach(el => el.alpha = 0);
    }

    public willPlayIntro(val:boolean):void{

        this.reelBGSpine.changeSpine("transporter");
        this.reelBGSpine.play({animation:"idle", loop:true, showOnEnd:true, freezed: !val });

        if(val) this.showIntroElements.forEach(el => el.alpha = 0);
        else{
            this.reelBG_Glow_Spine.stop();
        }
    }

    public PlayFlash():void{
        this.reelBG_Glow_Spine.play("animation");
    }

    public PlayIntro():gsap.core.Tween[]{
        return [
            gsap.fromTo(this.showIntroElements,{alpha:0},{alpha:1,duration:0.5,stagger:0.1}),
        ];
    }

    public static parseData(data: ReelGameData):void{ 
        this.AllReels.forEach(reel => { reel.parseData(data); });
        this.isGambleMode = (data.raw.mode == SanGameMode.FREESPIN_SETUP1 || data.raw.mode == SanGameMode.FREESPIN_SETUP2)
    }

    protected createReel(ID: number, initData: any): SanEngineController {
        return new SanEngineController(ID, this.reelConfig, initData);
    }

    protected createGraphic(color: number = 0x000000, alpha: number = 1): PIXI.Graphics {
        const extraWidth = 20;
        const w: number = (GameConfig.DEFAULT_SYMBOL_DIM.WIDTH * this.AllReels.length) + (GameConfig.DEFAULT_SYMBOL_DIM.PADDING_X * (this.AllReels.length-1)) + extraWidth;
        const h: number = GameConfig.DEFAULT_SYMBOL_DIM.HEIGHT * GameConfig.REEL_ENGINE_CONFIG.WINDOW_AMOUNT;
        const hOffset: number = h/this.reelConfig.WINDOW_AMOUNT;
        const ms: PIXI.Graphics = new PIXI.Graphics();
        ms.beginFill(color, alpha);
        ms.drawRect(-extraWidth/2, -hOffset/2, w, h);
        ms.endFill();
        this.addChild(ms);
        return ms;
    }

    public static onBeforeSpinStart(isNormal:boolean = false):void{
        this.isQuickStop = false;
        this.stopOrderIndx = 0;
    };
    
    public getReelPos(ReelID: number): PIXI.Point {
        return MathHelper.pointAdd(this.dim.position, SanEngineManager.getReel(ReelID).position);
    };

    public getSymSPPoint(ReelID: number, SymID: number): PIXI.Sprite {
        return SanEngineManager.getReel(ReelID).symPosPointer(SymID);
    };

    applyMask(val: boolean): void {
        this.reelContainer.mask = val ? this.maskObj : undefined!;
        this.maskObj.visible = val;
    }

    setFSReelAreaBG(val:boolean){
        this.reelBG.visible = val;
        this.reelBGSpine.animateSpineSwitch(val ? "inmate" : "transporter", { animation: val ? "idle_1" : "stop", loop:true },0.25);
        this.onResize();
    }

    applyBars(val:boolean):gsap.core.Timeline{

        SanEngineManager.barsApplied = val;
        SanEngineManager.revealer.reApplyToOriginCont();
        const topBot = SanEngineManager.revealer.topAndBotCont;

        const top = topBot[0];
        const bot = topBot[1];

        const dropDurr:number = 0.6;
        const corrDurr:number = dropDurr/4;// 0.2;

        const tl = Helper.setTimeline();

        if(val){
           
            tl.fromTo(top,{alpha:0,y:SanEngineManager.revealer.topContPos.y - 300} ,
                {alpha:1,duration:dropDurr ,y:SanEngineManager.revealer.topContPos.y, ease:"Back.easeIn" })
            tl.add(() => {
                SoundManager.playSoundEffect(SoundConfig.SETUP_2_APPLY_TOP_BOT_BARS)
            },dropDurr/2);
            tl.add(() => {
                SoundManager.playSoundEffect(SoundConfig.SETUP_2_APPLY_TOP_BOT_BARS)
            },dropDurr);
            tl.add(() => {
                ArrayHelper.shuffle([0,1,2,3,4]).forEach((indx) => {
                    const seq = SanQuentin2.overlay.playStandAloneSequence(SanQuentin2.assetLoader.getTextures("doorSparks")).item as Sequence;
                    seq.position = Helper.copyLocalPosition(seq,RevealerManager.getTopBar(indx));
                    seq.blendMode = BLEND_MODES.ADD;
                    seq.position.y += 40;
                    seq.scale.x = Math.random() > 0.5 ? 1 : -1;
                    seq.alpha = MathHelper.clamp(Math.random(),0.3,1); 
                })
            })
    
            tl.add([
                gsap.to(this,{y:this.dim.position.y + 10, duration:corrDurr, ease: "Back.easeOut"}),
                () => this.shakeScreen()
            ]);
    
            tl.fromTo(bot, { alpha: 0, y: SanEngineManager.revealer.botContPos.y + 300 },
                { alpha: 1, duration: dropDurr, y: SanEngineManager.revealer.botContPos.y, ease: "Back.easeIn" },dropDurr*0.5);
    
            tl.add(() => {
                ArrayHelper.shuffle([0,1,2,3,4]).forEach((indx) => {
                    const seq = SanQuentin2.overlay.playStandAloneSequence(SanQuentin2.assetLoader.getTextures("doorSparks")).item as Sequence;
                    seq.position = Helper.copyLocalPosition(seq,RevealerManager.getBotBar(indx));
                    seq.blendMode = BLEND_MODES.ADD;
                    seq.position.y -= 40;
                    seq.scale.y = -1;
                    seq.scale.x = Math.random() > 0.5 ? 1 : -1;
                    seq.alpha = MathHelper.clamp(Math.random(),0.3,1); 
                })
            })
            tl.add([
                gsap.to(this, { y: this.dim.position.y, duration: corrDurr, ease: "Back.easeOut" }),
                () => this.shakeScreen()
            ]);
        }else{
            topBot.forEach(v => v.alpha = 0);
        }

        return tl;
    }

    shakeScreen():void{
        AnimationEffects.Shake({
            x: 0,
            y: 1,
            obj: this.parent,
            hertz: 20,
            duration: 0.4,
            updateOnComplete: true,
            positionCb: () => new PIXI.Point(360, 360),
            Intensity: 2,
            ease:Back.easeOut
        });
    }

    private screenTL:gsap.core.Timeline
    bounceScreen(scale:number= 1.05, durr:number = 0.7): void {
        const toScale: PIXI.Point = MathHelper.pointMul(this.parent.scale, scale);

        const startDurr = 0.08;
        const outDurr = 2;

        this.screenTL = Helper.setTimeline(this.screenTL);
        this.screenTL.to(this.parent.scale, { x: toScale.x, y: toScale.y, duration: startDurr},0)
        this.screenTL.to(this.parent.scale, { x: 1, y: 1, duration: outDurr, ease:"Power3.easeOut"},startDurr)
    }

    ZoomIn(goAway:boolean,durr:number = 1):gsap.core.Timeline{
        const toScale = goAway ? {x:this.dim.scale.x*1.15,y:this.dim.scale.y*1.15} : {x:this.dim.scale.x,y:this.dim.scale.y};

        const tl = Helper.setTimeline(undefined, {
            onComplete: () => {
                if(goAway){
                    this.position.set(355,158);
                    this.pivot.set(355,0);
                }else
                    this.position = this.dim.position;

                if(SanEngineManager.isGambleMode && !ResizeHelper.isLandscape){
                    this.position.set(14,122);
                }
                this.pivot.set(0);
                this.onResize();
            }
        })
        tl.to(this.scale,{x:toScale.x,y: toScale.y,duration:durr},0)
        tl.to(this,{alpha: goAway ? 0 : 1 , duration:durr},0);
        if(goAway)
            tl.to(this,{x: "-=50", duration:durr},0);
      
        return tl;
    }

    transitMovement(goAway:boolean,durr:number = 1){
        if(!goAway){
            let yPos = (SanEngineManager.isGambleMode && !ResizeHelper.isLandscape) ? 122 : this.dim.position.y;
            this.position.y = yPos + 200;
        }
        return CommonAnimations.transitMovement(this, durr, goAway, goAway ? 200 : -200).eventCallback("onComplete",()=> { this.onResize();});
    }

    onResize(): void {
        super.onResize();

        if(SanEngineManager.isGambleMode && !ResizeHelper.isLandscape){
            this.position.set(14,122);
        }
        
        SanEngineManager.RSAll((rc,s) => s.onResize() );
        SanEngineManager.revealer.onResize();
        SanEngineManager.callReSizeStack.forEach(f => f());

        if(this.reelBG.visible){ // this.reelBG.visible = false = BaseGame
            if(!ResizeHelper.isLandscape){
                this.reelBGSpine.position.set(358,266)
                this.reelBGSpine.scale.set(0.8,0.8)
            }else{
                this.reelBGSpine.position.set(358,325)
                this.reelBGSpine.scale.set(0.99,1.1)
            }
        }else{
            this.reelBGSpine.position.set(358,325)
            this.reelBGSpine.scale.set(0.99,1.1)
        }
    }
}